

import React, { useContext, useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { useFormik } from "formik"
import * as Yup from "yup"
import classnames from "classnames"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Nav,
  NavItem,
  NavLink,
  Row,
  Button,
  UncontrolledTooltip
} from "reactstrap"
import { isEmpty } from "lodash"
import Pagination from "../Dealer-order2/Pagination"
import "nouislider/distribute/nouislider.css"
import {
  getCategoryList,
  getModelList,
  getProductsList,
  getSubCategoriesList,
} from "http/products/products"
import { CartContext } from "context/cartContext"
import ToastDialog from "components/Common/ToastDialog"
import _debounce from "lodash/debounce"
import { WishlistContext } from "context/wishlistContext"
import ProductTable from "./ProductTable"
import DeleteModal from "components/Common/DeleteModal"
import CustomLoader from "components/CustomLoader"
import { formatNumberWithCommas, } from '../../common/utility'
import { sub } from "date-fns"
const EcommerceProducts = props => {
  //meta title
  document.title = "Products | DMS"
  const navigate = useNavigate()
  const [productList, setProductList] = useState([])
  const [activeTab, setActiveTab] = useState("1")
  const [page, setPage] = useState(1)
  const [totalPage, setTotalPage] = useState(0)
  const [modal, setModal] = useState(false)
  const [customer, setCustomer] = useState(null)
  const user = JSON.parse(localStorage.getItem("user"))
  const [searchKey, setSearchKey] = useState("")
  const [searchValue, setSearchValue] = useState("")
  const roleName = user.roleName
  const [filterCategories, setFilterCategories] = useState([])
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [expandedSubCategories, setExpandedSubCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([])
  const [models, setModels] = useState([])
  const { addItemToCart, cartItems, getCartData } = useContext(CartContext)
  const {
    wishlistItems,
    getWishlistData,
    addItemToWishList,
    removeItemFromWishlist,
  } = useContext(WishlistContext)
  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const [filter, setFilter] = useState({ category: "", subCategories: "" })
  const [deleteModal, setDeleteModal] = useState({ open: false, id: null })
  const [quantityMap, setQuantityMap] = useState({})
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [productWithInfo ,setProductWithInfo] = useState([])


  const handleCategoryToggle = categoryName => {
    if (expandedCategories.includes(categoryName)) {
      setExpandedCategories([]);
    } else {
      setExpandedCategories([categoryName]);
    }
  }

  const handleSubCategoryToggle = subCategoryName => {
    if (expandedSubCategories.includes(subCategoryName)) {
      setExpandedSubCategories([]);
    } else {
      setExpandedSubCategories([subCategoryName]);
    }
  }

  useEffect(() => {
    fetchProductsList()
    fetchCategories()
    fetchSubCategories()
    fetchModelList()
  }, [])

  useEffect(() => {
    fetchProductsList()
  },[activeTab])

  useEffect(() => {
    handleFilter()
  }, [searchKey])

  const fetchCartList = async () => {
    try {
      await getCartData()
    }
    catch (e) { setToastInfo({ message: err.message, showToast: true, role: "error", }) }
  }

  const fetchProductsList = async () => {
    try {
      setLoading(true)
      const {
        data: responseData,
        code,
        status,
      } = await getProductsList({
        page: page,
        searchKey: searchKey,
        filterKey: filter,
      })

      if (status && code == 200) {
        const {
          currentPage,
          totalPages,
          totalItems,
          data: productList,
        } = responseData
        setPage(currentPage)
        setTotalPage(totalPages)
        setProductList(productList)
        setPagination({
          pageIndex: currentPage,
          pageCount: totalPages,
          totalRecords: totalItems,
        })
        for (let product of productList){
          setQuantityMap(prev => ({
            ...prev,
            [product.id]: product.minQty || 0
          }))
        }
      } else {
        setPage(0)
        setTotalPage(0)
        setProductList([])
      }
      setTimeout(() => {
        setLoading(false)
      }, 500)

    } catch (error) {
      setProductList([])
      setTimeout(() => {
        setLoading(false)
      }, 500)
      console.error("Error fetching product list:", error.message)
    }
  }

  const fetchCategories = async () => {
    try {
      const {
        data: responseData,
        code,
        status,
      } = await getCategoryList()
      if (status && code == 200) {
        setFilterCategories(responseData.data)
      } else {
        setFilterCategories([])
      }
    } catch (e) {
      setToastInfo({
        message: e,
        showToast: true,
        role: "error",
      })
    }
  }

  const fetchSubCategories = async () => {
    try {
      const {
        data: responseData,
        status,
        code,
      } = await getSubCategoriesList({
        limit: 100,
      })
      if (status && code == 200) {
        setSubCategories(responseData.data)
      } else {
        setSubCategories([])
      }
    } catch (err) {
      setToastInfo({
        message: err,
        showToast: true,
        role: "error",
      })
    }
  }

  const fetchModelList = async () => {
    try {
      const {
        data: responseData,
        status,
        code,
      } = await getModelList({
        limit: 100,
      })
      if (status && code == 200) {
        setModels(responseData.data)
      } else {
        setModels([])
      }
    } catch (err) {
      setToastInfo({
        message: err,
        showToast: true,
        role: "error",
      })
    }
  }

  const fetchWishlist = async () => {
    try {
      await getWishlistData()
    } catch (e) {
      setToastInfo({
        message: err.message,
        showToast: true,
        role: "error",
      })
    }
  }

  const addToCart = async (id, productQuantity, minQty,maxQty,lotSize) => {
    try {
      if (productQuantity > 0) {
        // if (productLotSize) {
        //   if (productQuantity % productLotSize !== 0) {
        //     setToastInfo({
        //       message:
        //         "Please select a quantity that is a multiple of the lot size.",
        //       showToast: true,
        //       role: "error",
        //     })
        //     setQuantityMap(prev => ({
        //       ...prev,
        //       [id]: 0,
        //     }))
        //     return
        //   }
        // }
        const addedToCart= await addItemToCart({
          productId: id,
          quantity: productQuantity,
          minQty,
          maxQty,
          lotSize
        })
        if(addedToCart.status){
          setToastInfo({
            message: "Product added to cart successfully",
            showToast: true,
            role: "success",
          })
          fetchCartList()
          setQuantityMap(prev => ({
            ...prev,
            [id]: minQty || 0,
          }))
        }else{
          setToastInfo({
            message: addedToCart.message,
            showToast: true,
            role: "error",
          })
          setQuantityMap(prev => ({
            ...prev,
            [id]: minQty || 0,
          }))
        }
      } else {
        setToastInfo({
          message: "Please select a quantity greater than zero",
          showToast: true,
          role: "error",
        })
        setQuantityMap(prev => ({
          ...prev,
          [id]: minQty || 0,
        }))
      }
    } catch (e) {
      setToastInfo({
        message: e.message,
        showToast: true,
        role: "error",
      })
      setQuantityMap(prev => ({
        ...prev,
        [id]: minQty || 0,
      }))
    }
  }

  const addToWishlist = async id => {
    try {
      await addItemToWishList({
        productId: id,
      })
      setToastInfo({
        message: "Product added to wishlist successfully",
        showToast: true,
        role: "success",
      })
      fetchWishlist()
    } catch (e) {
      setToastInfo({
        message: e.message,
        showToast: true,
        role: "error",
      })
    }
  }

  const handleDelete = async id => {
    try {
      let res = await removeItemFromWishlist({ productId: id })
      const { message } = res
      setToastInfo({
        message: message,
        showToast: true,
        role: "success",
      })
      fetchWishlist()
    } catch (err) {
      setToastInfo({
        message: err.message,
        showToast: true,
        role: "error",
      })
    }
  }

  const handleWishlist = product => {
    if (!product?.isInWishList) {
      addToWishlist(product.id)
    } else {
      handleDelete(product.id)
    }
  }

  const handleSearch = _debounce(e => {
    setSearchKey(e.target.value)
  }, 300)

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  const getCustomerPropertyValue = (customer, propertyName) => (customer && customer[propertyName]) || "";

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: getCustomerPropertyValue(customer, "Id"),
      itemName: getCustomerPropertyValue(customer, "itemName"),
      img: getCustomerPropertyValue(customer, "img"),
      category: getCustomerPropertyValue(customer, "category"),
      rating: getCustomerPropertyValue(customer, "rating"),
      sellingPrice: getCustomerPropertyValue(customer, "sellingPrice"),
      availablePackSize: getCustomerPropertyValue(customer, "availablePackSize"),
      USP: getCustomerPropertyValue(customer, "USP"),
      DoseAcre: getCustomerPropertyValue(customer, "DoseAcre"),
      timeOfApplication: getCustomerPropertyValue(customer, "timeOfApplication"),
    },

    validationSchema: Yup.object({
      itemName: Yup.string().required("Item Name is required"),
      img: Yup.string().required("Image URL is required"),
      category: Yup.string().required("Category is required"),
      rating: Yup.number()
        .required("Rating is required")
        .min(1, "Rating must be at least 1")
        .max(5, "Rating cannot exceed 5"),
      sellingPrice: Yup.number().required("Selling Price is required"),
      availablePackSize: Yup.string().required(
        "Available Pack Size is required"
      ),
      USP: Yup.string().required("USP is required"),
      SKU: Yup.string().required("SKU is required"),
      DoseAcre: Yup.string().required("Dose per Acre is required"),
      timeOfApplication: Yup.string().required(
        "Time of Application is required"
      ),
    }),

    onSubmit: values => {
      validation.resetForm()
      toggle()
    },
  })

  const toggle = () => {
    if (modal) {
      setModal(false)
      setCustomer(null)
    } else {
      setModal(true)
    }
  }

  const handleFilter = async () => {
    try {
      const {
        data: responseData,
        status,
        code,
      } = await getProductsList({ filterKey: filter, searchKey: searchKey ? searchKey : null })

      if (status && code == 200) {
        const {
          currentPage,
          totalPages,
          totalItems,
          data: productList,
        } = responseData
        setPage(currentPage)
        setTotalPage(totalPages)
        setProductList([])
        setProductList(productList)
        setPagination({
          pageIndex: currentPage,
          pageCount: totalPages,
          totalRecords: totalItems,
        })
      } else {
        setPage(0)
        setTotalPage(0)
        setProductList([])
        setPagination({
          pageIndex: 0,
          pageCount: 0,
          totalRecords: 0,
        })
      }
    } catch (error) {
      console.error("Error fetching product list:", error.message)
      setProductList([])
    }
  }

  useEffect(() => {
    handleFilter()
  }, [filter])

  useEffect(() => {
    fetchProductsList()
  }, [page])

  const handleDeleteProduct = async id => {
    setDeleteModal({ open: false, id: null })
    fetchProductsList()
  }

  const handlePageChange = (page, pageS, searchKey = "") => {
    setPage(page)

  }

  useEffect(() => {
    callAllProducts()
  },[productList, cartItems, wishlistItems])

  const callAllProducts = ()=>{
    const prodInfo = productList?.map(product => {
      return {
        ...product,
        isInCart: cartItems?.some(item => item?.product?.id === product?.id),
        isInWishList: wishlistItems?.some(
          item => item?.product?.id === product?.id
        ),
      }
    });
    setProductWithInfo(prodInfo)
  }
  return (
    <div className="page-content">
      <Container fluid>
        <div className="d-flex flex-column">
          <div className="d-flex align-items-center justify-content-between page-title-box">
            <div>
              <h5>Products</h5>
            </div>
            <div>
              <Form className="mt-4 mt-sm-0 float-sm-end d-sm-flex align-items-center">
                {activeTab === "1" && (
                  <div
                    style={{
                      border: "1px solid #adb5bd",
                      borderRadius: "1rem",
                    }}
                    className="search-box me-2"
                  >
                    <div className="position-relative">
                      <Input
                        type="text"
                        className="form-control border-0"
                        placeholder="Search..."
                        onChange={e => {
                          handleSearch(e)
                          setSearchValue(e.target.value)
                        }}
                        id="search-bar-0"
                        value={searchValue}
                      />
                      <UncontrolledTooltip
                        placement="bottom"
                        target="search-bar-0"
                        trigger="hover"
                      >
                        Search by Product Name, Category, Sub Category, Product Code, Model Name
                      </UncontrolledTooltip>
                      <i className="bx bx-search-alt search-icon" />
                    </div>
                  </div>
                )}
                {roleName !== "dealer" && (
                  <Nav
                    className="product-view-nav justify-content-end mt-3 mt-sm-0"
                    pills
                  >
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "1",
                        })}
                        onClick={() => {
                          toggleTab("1")
                        }}
                      >
                        <i className="bx bx-grid-alt" />
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "2",
                        })}
                        onClick={() => {
                          toggleTab("2")
                        }}
                      >
                        <i className="bx bx-list-ul" />
                      </NavLink>
                    </NavItem>
                  </Nav>
                )}
              </Form>
            </div>
          </div>
          <Row>
            {activeTab === "1" && (
              <Col lg="3" style={{ height: "fit-content" }}>
                <Card>
                  <CardBody>
                    <CardTitle className="mb-4">Filter</CardTitle>
                    <div>
                      <h5 className="font-size-14 mb-3">Category</h5>
                      <ul className="list-unstyled product-list">
                        <li>
                          <Link
                            className={
                              filter.category === ""
                                ? "text-success fw-medium"
                                : "text-body-tertiary"
                            }
                            onClick={() => {
                              setFilter({ category: "", subCategory: "" })
                              setExpandedCategories([])
                            }}
                          >
                            <i className={`mdi mdi-chevron-right me-2`} />
                            All
                          </Link>
                        </li>
                        {filterCategories?.length > 0 &&
                          filterCategories?.map((category,index) => (
                            <li key={"_li_" + index}>
                              <Link
                                onClick={() => {
                                  handleCategoryToggle(category.categoryName)
                                  setFilter({
                                    category: category.id,
                                    subCategory: "",
                                  })
                                }}
                                className={
                                  filter.category === category.id
                                    ? "text-success fw-medium"
                                    : "text-body-tertiary"
                                }
                              >
                                <i
                                  className={`mdi mdi-chevron-${expandedCategories.includes(
                                    category.categoryName
                                  )
                                    ? "down text-success"
                                    : "right"
                                    } me-2`}
                                />
                                {category.categoryName}
                              </Link>
                              {expandedCategories.includes(
                                category.categoryName
                              ) && (
                                  <ul
                                    style={{ marginLeft: "10px", fontSize: "12px" }}
                                    className="list-unstyled product-list"
                                  >
                                    {subCategories
                                      .filter(i => i.categoryId === category.id)
                                      .map((subcat,index) => (
                                        <li key={"_subli_" + index}>
                                          <Link
                                            onClick={() => {
                                              handleSubCategoryToggle(subcat.subCategoryName)
                                              setFilter({
                                                category: filter.category,
                                                subCategory: subcat.id,
                                              })
                                            }}
                                            className={
                                              filter?.subCategory === subcat.id
                                                ? "text-success"
                                                : ""
                                            }
                                          >
                                            <i className="mdi mdi-chevron-right me-2" />
                                            {subcat.subCategoryName}
                                          </Link>
                                          {expandedSubCategories.includes(
                                            subcat.subCategoryName
                                          ) && (
                                              <ul
                                                style={{ marginLeft: "10px", fontSize: "12px" }}
                                                className="list-unstyled product-list"
                                              >
                                                {models
                                                  .filter(i =>  i.subCategoryId === subcat.id && i.categoryId === subcat.categoryId)
                                                  .map((model,index) => (
                                                    <li key={"_subli_" + index}>
                                                      <Link
                                                        onClick={() => {
                                                          // handleSubCategoryToggle(subcat.subCategoryName)
                                                          setFilter({
                                                            category: filter.category,
                                                            subCategory: filter?.subCategory,
                                                            model: model.id
                                                          })
                                                        }}
                                                        className={
                                                          filter.model === model.id
                                                            ? "text-success"
                                                            : ""
                                                        }
                                                      >
                                                        <i className="mdi mdi-chevron-right me-2" />
                                                        {model.modelName}
                                                      </Link>
                                                    </li>
                                                  ))}
                                              </ul>
                                            )}
                                        </li>
                                      ))}
                                  </ul>
                                )}
                            </li>
                          ))}
                      </ul>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            )}
            <Col lg={activeTab === "1" ? 9 : 12} className="mt-3 mt-lg-0">
              {activeTab === "1" && (
                <>
                  <Row className="g-3">
                    {!loading ? (
                      <>
                        {productWithInfo.length > 0 ? (
                          productWithInfo?.map((product,index) => {
                            let imgUrl = product.image
                            let productQuantity =
                              quantityMap[product.id] || 0
                            return (
                              <Col xl={4} sm={6} key={"_col_" + index}>
                                <Card
                                  style={{
                                    height:
                                      roleName === "dealer" ? "470px" : "360px",
                                  }}
                                >
                                  <CardBody>
                                    <div className="position-relative">
                                      <div className="text-sm-end">
                                        <span className="rounded-circle">
                                          {roleName !== "dealer" && (
                                            <>
                                              <i
                                                onClick={() => {
                                                  navigate(
                                                    `/${roleName}/addProduct?id=${product.id}`
                                                  )
                                                }}
                                                className="mdi mdi-pencil font-size-17 text-success me-1 tool-icon "
                                                id="edittooltip"
                                              ></i>
                                              <UncontrolledTooltip
                                                placement="top"
                                                target="edittooltip"
                                              >
                                                Edit
                                              </UncontrolledTooltip>
                                            </>
                                          )}
                                          {roleName === "dealer" ? (
                                            <a
                                              // href="#"
                                              className="text-sm-end"
                                              style={{
                                                // marginLeft: "10px",
                                                color: "black",
                                              }}
                                              onClick={() => {
                                                handleWishlist(product)
                                              }}
                                            >
                                              {product?.isInWishList ? (
                                                <span>
                                                  <i
                                                    style={{
                                                      fontSize: "1.1rem",
                                                      color: "#f46a6a",

                                                    }}
                                                    className="mdi mdi-heart tool-icon-heart"
                                                  ></i>
                                                </span>
                                              ) : (
                                                <span>
                                                  <i
                                                    style={{
                                                      fontSize: "1.1rem",
                                                    }}
                                                    className="mdi mdi-heart-outline tool-icon-heart"
                                                  ></i>
                                                </span>
                                              )}
                                            </a>
                                          ) : null}
                                        </span>
                                      </div>
                                      {/* ) : null} */}
                                      <div className="product-img">
                                        {
                                          imgUrl?.paths?.original ? (
                                            <img
                                              src={process.env.REACT_APP_IMAGE_URL + imgUrl?.paths?.original}
                                              alt=""
                                              className="img-fluid d-block"
                                              style={{
                                                height: "10rem",
                                                cursor: "pointer",
                                                width: '100%'
                                              }}
                                              onError={(e) => {
                                                e.target.onerror = null; // Prevents infinite looping if default image also fails to load
                                                e.target.src = '/no-image.png';
                                                e.target.style.width = '5rem';
                                                e.target.style.height = '5rem';
                                              }}
                                              onClick={() => {
                                                navigate(
                                                  `/${roleName === "dealer"
                                                    ? "customer"
                                                    : roleName
                                                  }/product-detail/${product.id}`
                                                )
                                                
                                              }}
                                            />
                                          ) : (
                                            <img
                                              src={
                                                "/no-image.png"
                                              }
                                              alt=""
                                              className="img-fluid mx-auto d-block"
                                              style={{
                                                // height: "10rem",
                                                cursor: "pointer",
                                                width: '5rem'
                                              }}
                                              onClick={() => {
                                                navigate(
                                                  `/${roleName === "dealer"
                                                    ? "customer"
                                                    : roleName
                                                  }/product-detail/${product.id}`
                                                )
                                              }}
                                            />
                                          )
                                        }

                                      </div>

                                    </div>
                                    <div className="mt-1 text-center">
                                      <h5
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                        className="mb-1 text-truncate"
                                      >
                                        <Link
                                          to={
                                            `/${roleName === "dealer"
                                              ? "customer"
                                              : roleName
                                            }/product-detail/${product.id}`
                                          }
                                          className="text-dark"
                                        >
                                          {product.productName}{" "}
                                        </Link>
                                      </h5>
                                      <p
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                        className="mb-1"
                                      >
                                        <b>Product Code : </b>

                                        {product?.productCode}
                                      </p>
                                      <p
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                        className="mb-1"
                                      >
                                        <b>Category : </b>
                                        
                                        {product?.categoryName}
                                      </p>

                                      <p
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                        className="mb-1"
                                      >
                                        <b>Sub Category : </b>
                                        {product?.subCategoryName}
                                      </p>

                                      <p
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                        className="mb-1"
                                      >
                                        <b>Model : </b>
                                        {product?.modelName}
                                      </p>


                                      <p className="mb-1">
                                        <b>Price : </b>
                                        {formatNumberWithCommas(product.sellingPrice)}
                                      </p>
                                      {roleName === "dealer" && (
                                        <>
                                          <h6 className="mb-1">
                                            <b>
                                              Quantity{" "}
                                              <i
                                                className="bx bx-info-circle"
                                                title={product.maxQty? `You can order this product with minimum quantity of ${product?.minQty}, \nmaximum quantity of ${product?.maxQty} in a lot size(multiple) of ${product.lotSize || 1}` : "No limit is set for this product"}
                                              ></i>{" "}
                                              :{" "}
                                            </b>
                                          </h6>
                                          <div className="mt-2 mb-2">
                                            <div
                                              style={{
                                                width: "150px",
                                                margin: "auto",
                                              }}
                                            >
                                              <div style={{ display: 'flex', alignItems: 'center' }} className="input-group">
                                                <div className="input-group-prepend">
                                                  <button
                                                    type="button"
                                                    className="btn"
                                                    style={{ border: 'none', fontSize: '20px', }}
                                                    disabled={
                                                      product.isInCart
                                                    }
                                                    onClick={() => {
                                                      setQuantityMap(prev => ({
                                                        ...prev,
                                                        [product.id]: Math.max(
                                                          0,
                                                          productQuantity - 1
                                                        ),
                                                      }))
                                                    }}
                                                  >
                                                    -
                                                  </button>
                                                </div>
                                                <Input
                                                  type="text"
                                                  value={productQuantity}
                                                  name="demo_vertical"
                                                  className="text-center"
                                                  style={{ height: '2.1rem' }}
                                                  disabled={
                                                    product.isInCart
                                                  }
                                                  onChange={e => {
                                                    if (
                                                      e.target.value.length >=  9
                                                    ) {
                                                      setToastInfo({
                                                        message:
                                                          "The maximum quantity limit for this item has been exceeded. Please adjust your quantity accordingly.",
                                                        showToast: true,
                                                        role: "error",
                                                      })
                                                      return
                                                    }
                                                    const value = parseInt(
                                                      e.target.value,
                                                      10
                                                    )
                                                    setQuantityMap(prev => ({
                                                      ...prev,
                                                      [product.id]: isNaN(value)
                                                        ? 0
                                                        : value,
                                                    }))
                                                    productQuantity = 0
                                                  }}
                                                />
                                                <div className="input-group-append">
                                                  <button
                                                    type="button"
                                                    className="btn"
                                                    style={{ border: 'none', fontSize: '18px', }}
                                                    disabled={
                                                      product.isInCart
                                                    }
                                                    onClick={() => {
                                                      setQuantityMap(prev => ({
                                                        ...prev,
                                                        [product.id]:
                                                          productQuantity + 1,
                                                      }))
                                                    }}
                                                  >
                                                    +
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      )}

                                      {product.timeOfApplication ? (
                                        <p>
                                          Time Of Application:
                                          {product.timeOfApplication}
                                        </p>
                                      ) : null}
                                      {!product.status &&
                                        roleName === "dealer" ? (
                                        <div
                                          style={{
                                            width: "100%",
                                            marginTop: "-18px",
                                          }}
                                        >
                                          <Button
                                            type="button"
                                            color="primary"
                                            className="btn mt-4 mb-0"
                                            style={{ backgroundColor: '#344fa0', border: 'none', }}
                                            disabled={
                                              product.isInCart
                                            }
                                            onClick={() => {
                                              addToCart(
                                                product.id,
                                                productQuantity,
                                                +product?.minQty,
                                                +product?.maxQty,
                                                +product?.lotSize
                                              )
                                            }}
                                          >
                                            {product.isInCart ? (
                                              <>
                                                <i className="fas fa-shopping-cart" />{" "}
                                                Added to cart
                                              </>
                                            ) : (
                                              <>
                                                <i className="fas fa-shopping-cart" />{" "}
                                                Add to cart
                                              </>
                                            )}
                                          </Button>
                                        </div>
                                      ) : null}
                                      {product.status && roleName !== "admin" ? (
                                        <div
                                          style={{
                                            width: "100%",
                                            marginTop: "-20px",
                                          }}
                                        >
                                          <button
                                            type="button"
                                            className="btn mt-2 mb-0"
                                            style={{
                                              border: "none",
                                              color: "red",
                                            }}
                                          >
                                            {product.status}
                                          </button>
                                        </div>
                                      ) : null}
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                            )
                          })
                        ) : (
                          <>
                            <div
                              style={{ textAlign: "center", marginTop: "50px" }}
                            >
                              <h2>No Products Available</h2>
                              <p>
                                It seems there are no products in our catalog at
                                the moment.
                              </p>
                              <img
                                src="/empty_product.svg"
                                alt="Empty Product List"
                                style={{
                                  width: "300px",
                                  height: "300px",
                                  marginTop: "20px",
                                }}
                              />
                              <p>
                                Please check for available products or explore our
                                other offerings.
                                {/* <a href="/customer/listProduct">Check Products</a> */}
                              </p>
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <div
                        style={{
                          height: "60vh",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: 'column'
                        }}
                      >
                        <CustomLoader />
                        <div style={{ marginTop: "20px", textAlign: "center" }}>
                          <p style={{ color: "#9b9b9b" }}>
                            Please wait while we fetch products.
                          </p>
                        </div>
                      </div>
                    )}
                  </Row>
                  {!loading && pagination.pageCount != 0 && (
                    <div style={{ margin: "2% 0px 10% 30%" }}>
                      <Pagination
                        pagination={pagination}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  )}
                </>
              )}
              {activeTab === "2" && <ProductTable />}
            </Col>
          </Row>

        </div>
      </Container>
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
      <DeleteModal
        show={deleteModal.open}
        onDeleteClick={() => {
          handleDeleteProduct(deleteModal.id)
        }}
        onCloseClick={() => setDeleteModal({ open: false, id: null })}
      />
    </div>
  )
}

EcommerceProducts.propTypes = {
  products: PropTypes.array,
  onGetProducts: PropTypes.func,
}

export default withRouter(EcommerceProducts)

